import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isFormFieldInvalidAndTouched',
  standalone: false
})
export class IsFormFieldInvalidAndTouchedPipe implements PipeTransform {
  transform(
    formControlTouched?: boolean,
    formControlInvalid?: boolean,
    formTouched?: boolean,
    formInvalid?: boolean
  ): boolean {
    if (formInvalid !== null && formInvalid !== undefined) {
      return !!(formInvalid && formTouched);
    } if (formControlInvalid !== null && formControlInvalid !== undefined) {
      return !!(formControlInvalid && formControlTouched);
    }
    return false;
  }
}
